import type { UserUuid } from "../identity";
/**
 * CU-86d44j2ac — the recipient shape the shared notification components need; the backend addresses
 * a USER, so Patient and the customer-directory row both satisfy it and nothing clinical belongs here.
 */
export interface NotificationRecipient {
	id: UserUuid;
	email?: string;
	phone?: string | null;
	first_name?: string | null;
	middle_name?: string | null;
	last_name?: string | null;
}

/**
 * CU-86d44j2ac — related_entity_type values; the notification service accepts a free string, so a
 * customer record is filed under its own value rather than as a patient.
 */
export const RELATED_ENTITY_TYPE_PATIENT = "patient";
export const RELATED_ENTITY_TYPE_CUSTOMER = "customer";
